import { FC, SVGAttributes } from 'react';

const ExpandMore: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L13.0607 15.3536C12.4749 15.9393 11.5251 15.9393 10.9393 15.3536L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ExpandMore;
